<template>
  <div v-show="showContent" class="coupon-list-popup">
    <div class="coupon-list-popup-shade" @click="hidePopup"></div>
    <div
      class="coupon-list-popup-light"
      :style="couponListPopupLightStyle"
    ></div>
    <div class="coupon-list-popup-content" :style="couponListPopupContentStyle">
      <a
        class="coupon-list-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
      <p class="coupon-list-popup-title">{{ letter.quanGift }}</p>
      <!-- <p class="coupon-list-popup-type-tip">{{ letter.quanGiftTips }}</p> -->
      <div class="coupon-swiper-container">
        <!-- 左右导航按钮 -->
        <div class="swiper-button-prev coupon-swiper-prev"></div>
        <div class="coupon-list-popup-swiper swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide coupon-slide"
              v-for="(item, index) in couponList"
              :key="`slide-${index}`"
            >
              <div
                class="coupon-slide-content"
                :style="couponSlideContentStyle"
              >
                <p v-if="item.TYPE === 0" class="coupon-slide-content-value">
                  {{ fullReductMoney }}<br />{{ currency }}
                </p>
                <p v-else class="coupon-slide-content-value">{{ discount }}%</p>
                <p class="coupon-slide-content-host">{{ hostName }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next coupon-swiper-next"></div>
      </div>

      <div class="coupon-list-popup-info">
        <p class="coupon-title">{{ tagText }}</p>
        <p class="coupon-valid">{{ localStartDate }} - {{ localEndDate }}</p>
        <p class="coupon-limit">
          <span
            class="coupon-limit-tip"
            v-if="fullReductLimitBottomMoney === 0"
          >
            {{ letter.couponNoLimit }}
          </span>
          <span class="coupon-limit-tip" v-if="fullReductLimitBottomMoney > 0">
            {{
              letter.couponFuilCanUse
                .replace('${price}', fullReductLimitBottomMoney)
                .replace('${currency}', currency)
            }}
          </span>
          <span class="coupon-limit-tip">
            {{
              letter.voucherLimitRegion
                ? letter.voucherLimitRegion.replaceAll('${currency}', currency)
                : ''
            }}
          </span>
          <span class="coupon-limit-tip">{{ useLimitTip }}</span>
        </p>
        <p
          class="coupon-item-discount"
          v-if="discountType && discountLimitTopMoney"
        >
          ({{
            letter.couponMaxDiscount
              .replace('${price}', discountLimitTopMoney)
              .replace('${currency}', currency)
          }})
        </p>
      </div>

      <a class="coupon-list-popup-btn" href="javascript:;" @click="hidePopup">
        {{ letter.known }}
      </a>

      <a
        class="coupon-list-popup-watch"
        href="javascript:;"
        @click="watchCoupon"
      >
        {{ letter.v3MyCoupons }} >>
      </a>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import Swiper from 'swiper';
import coupon from '@mixins/officialTopupNew/coupon';
import { times, couponLocalDateFormat } from '@utiles/officialStore';
import CouponItem from '@components/officialTopupNew/coupon/CouponItem.vue';

export default {
  name: 'couponListPopup',
  props: ['couponList'],
  mixins: [coupon],
  data() {
    return {
      visible: false,
      swiper: null,
      indexCoupon: 0,
      hostName: window.location.host.split('.')?.[1] || ''
    };
  },
  computed: {
    ...mapState({
      couponPopupPicList: state => state.page.couponPopupPicList,
      colorConfig: state => state.page.colorConfig,
      letter: state => state.letter,
      loading: state => state.loading
    }),
    showContent() {
      return this.visible && !this.loading;
    },
    couponListPopupContentStyle() {
      return `background-image: url(${this.couponPopupPicList?.sendCouponBg});`;
    },
    couponListPopupLightStyle() {
      return `background-image: url(${this.couponPopupPicList?.sendCouponBgLight});`;
    },
    couponSlideContentStyle() {
      return `background-image: url(${this.couponPopupPicList?.couponDiscountBg});`;
    },
    info() {
      return this.couponList?.[this.indexCoupon] || {};
    },
    fullReductMoney() {
      return this.info.REDUCTION_MONEY || 0;
    },
    discount() {
      return times(+this.info.DISCOUNT, 100);
    },
    currency() {
      return this.info?.CURRENCY || '';
    },
    tagText() {
      if (this.info.DESCRIPTION) {
        return this.info.DESCRIPTION;
      }
      if (this.fullReductType) {
        return this.letter.couponReductionType;
      }
      if (this.discountType) {
        return this.letter.couponDiscountType;
      }
      return '';
    },
    localStartDate() {
      return couponLocalDateFormat(this.info.START_TIME, this.lang);
    },
    localEndDate() {
      return couponLocalDateFormat(this.info.EXPIRY_TIME, this.lang);
    },
    fullReductLimitBottomMoney() {
      return +this.info.LIMIT_BOTTOM_MONEY || 0;
    },
    useLimitTip() {
      let tips = [];
      const productType = {
        coin: this.letter.couponOnlyCoinCanUse,
        package: this.letter.couponOnlyPackageCanUse,
        subscription: this.letter.couponOnlySubCanUse,
        currency: this.letter.couponOnlyDaibiCanUse
      };
      const hasPaytypeList =
        (this.info.PAY_TYPE_LIST && this.info.PAY_TYPE_LIST.length) || 0;
      const hasProductList =
        (this.info.PRODUCT_LIST && this.info.PRODUCT_LIST.length) || 0;
      const hasProductType = this.info.PRODUCT_TYPE || 0;

      if (hasProductType) {
        tips.push(productType[this.info.PRODUCT_TYPE]);
      }

      if (hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (hasPaytypeList && !hasProductList) {
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (!hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
      } else if (!hasPaytypeList && !hasProductList && !hasProductType) {
        tips.push(this.letter.couponAllProductCanUse);
      }

      return tips.join(';');
    },
    discountType() {
      return +this.info.TYPE === 1;
    },
    discountLimitTopMoney() {
      return +this.info.LIMIT_TOP_MONEY;
    }
  },
  mounted() {
    this.preloadImages().then(() => {
      this.visible = true;
      this.$nextTick(() => {
        this.initSwiper();
      });
    });
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  },
  methods: {
    // 预加载图片
    preloadImages() {
      const imagesToLoad = [];

      // 添加弹窗背景图片
      if (this.couponPopupPicList?.sendCouponBg) {
        imagesToLoad.push(this.couponPopupPicList.sendCouponBg);
      }

      // 添加弹窗光效背景图片
      if (this.couponPopupPicList?.sendCouponBgLight) {
        imagesToLoad.push(this.couponPopupPicList.sendCouponBgLight);
      }

      // 添加券折扣背景图片
      if (this.couponPopupPicList?.couponDiscountBg) {
        imagesToLoad.push(this.couponPopupPicList.couponDiscountBg);
      }

      // 创建图片预加载的Promise数组
      const imagePromises = imagesToLoad.map(imageUrl => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(imageUrl);
          img.onerror = () => {
            console.warn(`图片预加载失败: ${imageUrl}`);
            resolve(imageUrl); // 即使失败也继续，不阻塞展示
          };
          img.src = imageUrl;
        });
      });

      // 等待所有图片加载完成，或者设置一个超时时间
      return Promise.race([
        Promise.all(imagePromises),
        new Promise(resolve => setTimeout(resolve, 3000)) // 最多等待3秒
      ]);
    },
    hidePopup() {
      this.$emit('closeCouponPopup');
    },
    watchCoupon() {
      this.refreshGameCoupon();
      this.hidePopup();
    },
    initSwiper() {
      const _self = this;
      try {
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.coupon-list-popup-swiper', {
          loop: this.couponList.length > 1,
          autoplay: false,
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.coupon-swiper-next',
            prevEl: '.coupon-swiper-prev'
          },
          effect: 'slide',
          observer: true,
          observeParents: true,
          on: {
            slideChange: function () {
              _self.indexCoupon = this.realIndex;
            }
          }
        });
      } catch (err) {
        console.error('Swiper初始化失败:', err);
      }
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';

@keyframes rotate {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes scale-coupon {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.coupon-list-popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1002;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  &-light {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    animation: rotate 10s linear infinite;
  }
  &-content {
    overflow: hidden;
    box-sizing: border-box;
    z-index: 0;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 498px;
    height: 653px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    animation: scale-coupon 0.3s ease;
  }

  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 400px;
    height: 100px;
    margin: 90px auto 0;
    font-size: 42px;
    color: #ffffff;
    text-align: center;
  }
  &-close {
    box-sizing: border-box;
    position: absolute;
    top: 22px;
    right: 0;
    width: 40px;
    height: 40px;
    background-color: #b3b3b3;
    border-radius: 50%;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      margin: auto;
      background: url($commonImg + 'coupon-close.png') no-repeat center/contain;
    }
  }

  &-info {
    max-width: 410px;
    min-height: 120px;
    margin: 30px auto 0;
    font-size: 20px;
    color: #666666;
    text-align: center;

    .coupon-title {
      margin-bottom: 18px;
      font-size: 26px;
      font-weight: bold;
      color: $priceColor;
    }

    .coupon-valid,
    .coupon-limit {
      line-height: 1.3;
    }
  }

  &-btn {
    display: block;
    margin: 20px auto 20px;
    width: 410px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 26px;
    color: #ffffff;
    background: linear-gradient(
      348deg,
      $buttonGradientColor1,
      $buttonGradientColor2
    );
    border-radius: 10px;
  }

  &-watch {
    display: block;
    text-align: center;
    font-size: 22px;
    color: $buttonGradientColor1;
  }

  // 轮播外层容器样式
  .coupon-swiper-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 400px;
    height: 138px;
    margin: 20px auto 0;

    // 导航按钮样式
    .coupon-swiper-next,
    .coupon-swiper-prev {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 42px;
      height: 42px;
      background: #ffffff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &::after {
        content: '';
        display: block;
        border-radius: 1px;
      }

      &:hover {
        background: #f5f5f5;
      }
    }

    .coupon-swiper-next {
      right: 0;

      &::after {
        width: 10px;
        height: 10px;
        border-right: 5px solid $buttonGradientColor1;
        border-bottom: 5px solid $buttonGradientColor1;
        transform: rotate(-45deg);
        margin-left: -2px;
      }
    }

    .coupon-swiper-prev {
      left: 0;

      &::after {
        width: 10px;
        height: 10px;
        border-left: 5px solid $buttonGradientColor1;
        border-bottom: 5px solid $buttonGradientColor1;
        transform: rotate(45deg);
        margin-right: -2px;
      }
    }
  }

  // 轮播容器样式
  &-swiper {
    position: relative;
    width: 247px;
    height: 138px;

    .swiper-wrapper {
      height: 100%;
    }

    .coupon-slide {
      display: flex;
      align-items: center;
      justify-content: center;

      &-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        &-value {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          width: 156px;
          height: 100%;
          font-size: 35px;
          font-family: 'BAHNSCHRIFT';
          color: $priceColor;
          text-align: center;
        }

        &-host {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          writing-mode: vertical-rl; /* 从右到左的垂直文本 */
          font-size: 24px;
          color: #ffffff;
        }
      }
    }
  }
}

#ssr-page.landscape {
}
</style>
